import { useKeycloakStore } from '../hooks/zustandStore';
import { LoadingScreen } from '../components';
import { AsyncLegacyLogin } from '../pages/Login/LegacyLogin/async';
import KeycloakLogin from '../pages/Login/KeycloakLogin';

export function LoginRoute() {
  const isLegacyLogin = useKeycloakStore((state) => state.isLegacyLogin);
  const isLegacyLoginLoading = useKeycloakStore(
    (state) => state.isLegacyLoginLoading,
  );

  if (isLegacyLoginLoading || isLegacyLogin === null) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center px-4">
        <LoadingScreen
          title="Načítáme stránku"
          subTitle="Prosím, chvíli počkejte."
        />
      </div>
    );
  }

  if (isLegacyLogin) {
    return <AsyncLegacyLogin />;
  }

  return <KeycloakLogin />;
}
